// src/components/PracticeTest/ModuleList.jsx

import React from 'react';
import { Link } from 'react-router-dom';

export default function ModuleList({ posts, category }) {
  // Filter posts that belong to the active category
  const filteredPosts = posts.filter(post => {
    const postTag = post.tag || "General";
    return postTag === category;
  });

  if (filteredPosts.length === 0) {
    return <div className="animate-view empty-state">No modules found in this folder.</div>;
  }

  return (
    <div className="module-list animate-view">
      {filteredPosts.map(post => (
        <div key={post.id} className="module-card">
          <h4>{post.title}</h4>
          
          {/* Dynamically link to the new route using the post's unique ID */}
          <Link to={`/users/practice/pinterface/${post.id}`}>
            Start Practice
          </Link>
        </div>
      ))}
    </div>
  );
}